import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

interface Props {
  /** Add-in name of the page, the key below `pageHelp` in the locale files. */
  pageId: string;
}

/** Short help of a page: what it is for, then its functions (one per line in the locale). */
export function PageHelp({ pageId }: Props) {
  const { t, i18n } = useTranslation();
  const key = `pageHelp.${pageId}`;

  if (!pageId || !i18n.exists(`${key}.intro`)) {
    return <Typography variant="body2">{t("pageHelp.missing")}</Typography>;
  }

  const features = t(`${key}.features`).split("\n").filter(Boolean);

  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {t(`${key}.intro`)}
      </Typography>
      <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
        {t("pageHelp.featuresTitle")}
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 3, "& li": { mb: 0.75 } }}>
        {features.map(feature => (
          <Typography component="li" variant="body2" key={feature}>
            {feature}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}
